import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {Helmet} from 'react-helmet';
import { map, sumBy, capitalize } from 'lodash';
import { Link } from 'react-router-dom';
import Spinner from '../../components/common/Spinner';
import StatementPeriodDates from '../../components/pages/imports/StatementPeriodDates';
import ReactTable from 'react-table';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import { importsActions } from '../../data/actions/imports';
import CSV from '../../helpers/CSVExport';

var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class PaidReports extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
		this.exportToCsv = this.exportToCsv.bind(this);
	}
	
	componentDidMount() {
		const { match, dispatch, period } = this.props;
		this.props.dispatch(importsActions.getPaidReports(period));
		this.setState({
			period
		})

	}

	
	exportToCsv(){
		const { period } = this.state;
		let { reports } = this.props.imports;
		const filename = CSV.CSVHeader('paid_reports', period);
		return CSV.CSVExport(reports.data, {filename}, 'paid_reports');
	}
		
	render() {
		const { reportsLoading, reports = {}, approveRejectLoading} = this.props.imports,
			{ accepted } = this.props;
		let { columns = [], data = [] } = reports;
		if(columns.length > 0) {
			columns = columns.map(key=>({
				id: key,
				accessor: key,
				Header: capitalize(key),
				Cell: ({original}) => <span className="import-status">
					{original[`${key}_status`]}
					{original[`${key}_rows_loaded`] && <span className="import-status-count">{original[`${key}_rows_loaded`]}</span>}
					{original[`${key}_error_message`] && <span className="import-status-error" title={original[`${key}_error_message`]}><i className="fa fa-exclamation-triangle" /></span>}
				</span>
			}));
			columns.unshift({
				id: 'source_label',
				accessor: 'source_label',
				Header: 'Label',
				className: 'table-text-left name-cell',
				headerClassName: 'table-text-left'

			})
		} 
		
		return <div className="inner-page shared-pages">
			<div className="container">
				<h2>Paid Reports
				<a title="Export" onClick={()=>this.exportToCsv()} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
				{accepted && <span>Period already imported!</span>}
				</h2>
				<div className="ibox">
					<ReactTable
						data={data}
						loading={reportsLoading}
						columns={columns}
						pageSize={10}
						showPagination={data.length > 10}
						className="simple-table share-table"
					/>
				</div>
			</div>
			<Helmet>
				<title>Pending reports</title>
			</Helmet>

		</div>
	}
}

function mapStateToProps(state) {
	return {
		imports: state.imports
	} 
}

export default connect(mapStateToProps)(PaidReports)